import type { CSSInterpolation } from '@emotion/serialize';
import { Link } from 'gatsby';
import React, { use } from 'react';

import { getClubsLinkedToBuildType } from 'src/content/club-look-ups-by-id';
import { SiteContext } from 'src/context/site-context';
import type { BuildType } from 'src/enums/build/build-type';
import { shouldUseInternalClubPickerForBuildType } from 'src/enums/build/build-type';
import { TranslatedStaticText } from 'src/translators/static-text-translator';

type HeaderChangeClubProps = {
  isClubSelectDropdownVisible: boolean;
  toggleClubSelectDropdown: (expanded: boolean) => void;
  styles?: CSSInterpolation;
};

const HeaderChangeClub: React.FC<HeaderChangeClubProps> = ({
  isClubSelectDropdownVisible,
  toggleClubSelectDropdown,
  styles,
}) => {
  const { buildType } = use(SiteContext);
  const showClubSelectionDropdown = () => toggleClubSelectDropdown(!isClubSelectDropdownVisible);
  const changeClubText = <TranslatedStaticText lookupKey="changeClub" />;
  const shouldChangeClubHeaderBeShown = (buildType: BuildType) => {
    return getClubsLinkedToBuildType(buildType).length > 1;
  };

  return (
    <>
      {shouldChangeClubHeaderBeShown(buildType) &&
        (shouldUseInternalClubPickerForBuildType(buildType) ? (
          <div onClick={showClubSelectionDropdown} css={styles}>
            {changeClubText}
          </div>
        ) : (
          <Link to="/clubs" css={styles}>
            {changeClubText}
          </Link>
        ))}
    </>
  );
};

export default HeaderChangeClub;
